import React, { useRef } from 'react';
import Slider from "react-slick";
import "../carrosel/style.css"
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const Insidedivcarrosel = styled.div`
  padding: 20px 30px 40px;
  min-height: 500px;
  background-color: red;
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  background-size: cover;
  background-position: center;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  text-decoration: none;
  color: #fff;

  @media(min-width: 996px) {
    min-height: 450px;
  }

  @media(min-width: 1440px) {
    min-height: 700px;
  }

  .inside-content p,
  .inside-content h4,
  .inside-content h3  {
    opacity: 0;
    visibility: hidden;
    transform: translateY(10px);
    transition: opacity 1s ease, transform 1s ease;
  }

  .inside-content {
    position: relative;
    z-index: 2;
  }

  &:after {
    content: "";
    background: linear-gradient(180deg, rgb(0 0 0 / 59%) 50%, rgb(10 10 10) 100%);
    inset: 0;
    position: absolute;
    transition: opacity 0.3s ease;
    z-index: 1;
    pointer-events: none;
  }

  &:hover:after {
    background: linear-gradient(180deg, rgb(0 0 0 / 0%) 31%, rgb(0 0 0) 100%);
  }

  & h5{
    font-size: 30px;
    font-weight: 600;
    transform: translateY(-10px);
    transition: opacity 0.4s ease, transform 0.4s ease;
  }

  &:hover .inside-content p,
  &:hover .inside-content h4,
  &:hover .inside-content h3 {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
  }

  &:hover .inside-content h5{
    opacity: 0;
    visibility: hidden;
  }
`;

const CarroselClientes = () => {
  const sliderRef = useRef(null);
  const settings = {
    dots: false,
    infinite: true,
    arrows: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,  
    responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    };
    
    const handleNext = () => {
        sliderRef.current.slickNext();
    };

    const handlePrev = () => {
        sliderRef.current.slickPrev();
    };

  return (
    <div className='falsecontainer'>        
          <Slider ref={sliderRef} {...settings}>
            <div>
                <Link to="/fcopel" style={{ textDecoration: 'none' }}>
                    <Insidedivcarrosel
                        style={{
                        backgroundImage: 'url(/img/carrosel/copel.jpg)',
                        }}
                    >
                        <div className="inside-content">
                        <h3>FUNDAÇÃO COPEL</h3>
                        <h4>fcopel.org.br</h4>
                        <p>
                            Site principal sobre a Fundação Copel, maior entidade de fundo de pensão do sul do Brasil com o objetivo de garantir o pagamento de benefícios complementares à aposentadoria aos funcionários da COPEL (Cia Paranaense de Energia), COMPAGAS (Companhia Paranaense de Gás) e demais patrocinadores.
                        </p>
                        <h5>FUNDAÇÃO COPEL</h5>
                        </div>
                    </Insidedivcarrosel>
                </Link>
            </div>
            <div>
                <Link to="/energisaprev" style={{ textDecoration: 'none' }}>
                    <Insidedivcarrosel
                        style={{
                            backgroundImage: 'url(/img/carrosel/energisa.jpg)',
                        }}
                    >
                        <div className="inside-content">
                            <h3>EnergisaPrev</h3>
                            <h4>energisaprev.com.br/relatorioanual2023</h4>
                            <p >Desdobramento do Site principal da EnergisaPrev, dispondo das informações do relatório anual de investimentos do fundo previdenciário privado destinado aos associados do grupo Energisa, holding brasileira de distribuição de energia.</p>
                            <h5>EnergisaPrev</h5>
                        </div>
                    </Insidedivcarrosel>
                </Link>
            </div>
            <div>
                <Link to="/elosprev" style={{ textDecoration: 'none' }}>
                    <Insidedivcarrosel
                        style={{
                            backgroundImage: 'url(/img/carrosel/elos.jpg)',
                        }}
                    >
                        <div className="inside-content">
                            <h3>ELOS Previdência</h3>
                            <h4>elos.org.br</h4>
                            <p >Site criado para fundação previdenciária destinada à colaboradores da Eletrosul Centrais Elétricas (atual Eletrobras CGT Eletrosul) - concessionária de distribuição de energia elétrica na Região Sul e MS, e a A Engie (antiga GDF SUEZ) - o segundo maior grupo do ramo de energia no mundo.</p>
                            <h5>ELOS Previdência</h5>
                        </div>
                    </Insidedivcarrosel>
                </Link>
            </div>
            <div>
                <Link to="/prestador" style={{ textDecoration: 'none' }}> 
                    <Insidedivcarrosel
                        style={{
                            backgroundImage: 'url(/img/carrosel/copelprestadorl.jpg)',
                        }}
                    >
                        <div className="inside-content">
                            <h3>COPEL Prestador</h3>
                            <h4>prestador.fcopel.org.br</h4>
                            <p >Site ligado ao princiapl da Fundação COPEL, um portal direcionado aos beneficiários e contribuintes do fundo de aposentadoria complementar da Fundação COPEL.</p>
                            <h5>COPEL Prestador</h5>
                        </div>
                    </Insidedivcarrosel>
                </Link> 
            </div>
            <div>
                <Link to="/fundaffemg" style={{ textDecoration: 'none' }}>
                    <Insidedivcarrosel
                        style={{
                            backgroundImage: 'url(/img/carrosel/fundaffemg.jpg)',
                        }}
                    >
                        <div className="inside-content">
                            <h3>FUNDAFFEMG</h3>
                            <h4>fundaffemg.com.br</h4>
                            <p >Site principal da Fundação AFFEMG de Assistência e Saúde (FUNDAFFEMG); operadora de plano de saúde na modalidade de autogestão, criada pela Associação dos Funcionários Fiscais do Estado de Minas Gerais, entre Servidores Públicos, Auditores Fiscais da Receita Estadual, associados e seus dependentes.</p>
                            <h5>FUNDAFFEMG</h5>
                        </div>
                    </Insidedivcarrosel>
                </Link>
            </div>
            <div>
                <Link to="/sharknarguiles" style={{ textDecoration: 'none' }}>
                    <Insidedivcarrosel
                    style={{
                        backgroundImage: 'url(/img/carrosel/sharknarguile.jpg)',
                    }}
                >
                    <div className="inside-content">
                        <h3>SHARK NARGUILE</h3>
                        <h4>sharknarguile.com.br</h4>
                        <p >E-commerce desenvolvido para a venda de narguiles e variedade de produtos destinados ao consumo adulto.</p>
                        <h5>SHARK NARGUILE</h5>
                    </div>
                    </Insidedivcarrosel>
                </Link>
            </div>
        </Slider>

        <div className='navegacao__carrosel'>
            <button type="button" id="prev" aria-label="Voltar" onClick={handlePrev}></button>
            <span></span>
            <button type="button" id="next" aria-label="Proximo" onClick={handleNext}></button>
        </div>
    </div>

  );
};

export default CarroselClientes;
